import QuestionPageSecondaryHeader from '../QuestionPage/QuestionPageSecondaryHeader';
import KmxChatStroked from '@kmx/mui-icons/KmxChatStroked';
import KmxLocationFilled from '@kmx/mui-icons/KmxLocationFilled';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

import { openChat } from '../../../../../utilities/openChat';
import { useMuiMediaQuery } from '../../../../../utilities/hooks/useMuiMediaQuery';

const NeedMoreHelp = () => {
    const { isMobile } = useMuiMediaQuery();

    return (
        <Stack spacing={isMobile ? 2 : 3}>
            <QuestionPageSecondaryHeader>Need more help?</QuestionPageSecondaryHeader>
            <Grid container spacing={1}>
                <Grid size={{ xs: 6, sm: 3 }}>
                    <Button size="large" variant="outlined" startIcon={<KmxChatStroked />} onClick={openChat} fullWidth>
                        Chat
                    </Button>
                </Grid>
                <Grid size={{ xs: 6, sm: 3 }}>
                    <Button
                        size="large"
                        variant="outlined"
                        startIcon={<KmxLocationFilled />}
                        href="/browse-appointments?op=Faqpage"
                        fullWidth
                    >
                        Visit
                    </Button>
                </Grid>
            </Grid>
        </Stack>
    );
};

export default NeedMoreHelp;
